import { AmortizacionDetalle } from './amortizacion_detalle';

export class Amortizacion{
    public constructor(
        public id: String = "",
        public valor: number = 0,
        public numero_cuotas: number = 0,
        public documento_id: String = "",
        public tipo: String = "",
        public empresa_id: String = "",
        public usuario_id: String = "",

        public detalle: Array<AmortizacionDetalle> = [],
    ){
        //
    }
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/amortizacion.ts